var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5359 2.00018H7.12507C5.40217 2.00018 4 3.40213 4 5.12525V23.8764C4.00104 25.5989 5.40217 27 7.12507 27H24.5359C25.3495 27 25.7369 25.9939 25.135 25.4461C24.3387 24.68 24.3362 23.0738 25.1331 22.3067C25.3129 22.1446 25.4269 21.9102 25.4288 21.6497V21.6393V2.89292C25.4288 2.39965 25.0293 2 24.5359 2L24.5359 2.00018ZM8.9108 6.46449H20.518C20.7644 6.46449 20.9644 6.66441 20.9644 6.91083V13.1609C20.9644 13.4073 20.7644 13.6072 20.518 13.6072H8.9108C8.66437 13.6072 8.46445 13.4073 8.46445 13.1609V6.91083C8.46424 6.66441 8.66437 6.46449 8.9108 6.46449ZM22.9601 25.2146H7.12507C6.3866 25.2146 5.78583 24.6138 5.78583 23.8754C5.78583 23.1369 6.38665 22.5361 7.12507 22.5361H22.9601C22.6798 23.391 22.6798 24.3595 22.9601 25.2146Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.661L14.3661 14V16.1423C18.1898 16.3321 19.3017 18.6914 19.3017 22C18.4881 20.3729 17.1864 19.0983 14.3661 18.9899V21.322L10 17.661Z",
    fill: "#1A202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookReturn);
export default __webpack_public_path__ + "static/media/BookReturn.bfbc17997cfcea257670957f44e4689e.svg";
export { ForwardRef as ReactComponent };